import { format } from "date-fns";
import { MealBreakLastPunchLike, MealBreakWidgetConfig } from "../types";

type DashboardWidget = {
    widget_code?: string;
    visible?: boolean;
    config?: {
        workflow_code?: string;
        entry_id?: string | number;
    };
};

export const getMealBreakWidgetConfig = (widgets?: DashboardWidget[]): MealBreakWidgetConfig => {
    const mealBreakWidget = widgets?.find(
        (widget) => widget.widget_code === "skip_meal_break" || widget.widget_code === "meal_break"
    );

    return {
        visible: Boolean(mealBreakWidget?.visible),
        workflowCode: mealBreakWidget?.config?.workflow_code || "",
        entryId: mealBreakWidget?.config?.entry_id ? String(mealBreakWidget.config.entry_id) : "",
    };
};

export const shouldShowMealBreakTile = (config: MealBreakWidgetConfig): boolean => {
    return Boolean(config.visible && config.workflowCode);
};

export const formatMealBreakTime = (value?: string | Date | null): string => {
    if (!value) {
        return "";
    }

    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return format(date, "h:mm a");
};

export const getMealBreakToastMessage = (payload: unknown): string | undefined => {
    if (typeof payload === "string" && payload.trim()) {
        return payload;
    }

    if (
        payload &&
        typeof payload === "object" &&
        "message" in payload &&
        typeof payload.message === "string" &&
        payload.message.trim()
    ) {
        return payload.message;
    }

    return undefined;
};

export const getShiftStartedAtFromLastPunch = (lastPunch?: MealBreakLastPunchLike | null): string => {
    if (!lastPunch || lastPunch.reset_punch_state || String(lastPunch.punch_status) !== "0") {
        return "";
    }

    return formatMealBreakTime(lastPunch.datetime);
};
